import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class CookiesModal extends React.Component {
    render() { 
        return (
            <Dialog
                open={this.props.visible}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.props.ok}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">This Website Uses Cookies</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            This website uses cookies to maintain user sessions (so you don't need to log in every time you open the site) and to save viewing preferences.
                        </DialogContentText>
                    </DialogContent>
                <DialogActions>

                <Button onClick={this.props.not_ok}>
                    Disable Cookies
                </Button>

                <Button onClick={this.props.ok} color="primary">
                    Accept Cookies
                </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default CookiesModal;